<table class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th (click)="sortBy_click('customers.last_name')">
        Full Name {{ this._sortColumn === 'customers.last_name' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">Username</th>
      <th class="no-sort"></th>
      <th [hidden]="!this.options.allowEditing && !allowImpersonate"></th>
    </tr>
  </thead>
  <tbody>
    @if (loading) {
      <tr>
        <td colspan="4">
          <div class="cpo-table-loading">
            <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
          </div>
        </td>
      </tr>
    } @else {
      @for (
        item of this.dataSource.data;
        track item.id;
        let even = $even;
        let odd = $odd
      ) {
        @if (item.id != undefined) {
          <tr
            id="trsummary_{{ item.id }}"
            [ngClass]="{ even: even, odd: odd }"
            class="cpo-selectable-table__row"
            (click)="_selectRow_click(item.id)"
          >
            <td>
              {{ item.firstName }} {{ item.lastName }}
            </td>
            <td>
              {{ item.emailAddress }}
            </td>
            <td>
              <span
                [style]="
                  item.isDisabled
                    ? 'border-radius:4px; background-color:var(--colorAlert); font-size:.9em; color:#ffffff; padding:3px 6px;'
                    : ''
                "
                >{{ item.isDisabled ? 'Disabled' : '' }}</span
              >
            </td>
            <td
              style="width: 20%; text-align: right; white-space: nowrap;"
              [hidden]="!allowEditusers && !allowImpersonate"
            >
              <app-icon [style]="'cursor: pointer; margin-right: 30px;'" 
                [title]="allowEditusers? 'Edit ' + item.firstName + ' ' + item.lastName : 'You do not have permission to edit this account'" 
                color="var(--color-action-icon)" [hidden]="!allowEditusers"
                (click)="btnManageAccount_click(item.id)" type="Edit">
              </app-icon>
              <app-icon [style]="'cursor: pointer;'" (click)="impersonateUser(item.id)"
                [hidden]="!allowImpersonate" color="var(--color-action-icon)" [disabled]="item.isDisabled == true || !allowImpersonate || !item.canBeImpersonated ? 'disabed' : ''"
                [title]="impersonationNotAllowedReason != '' ? impersonationNotAllowedReason : userIsSelf(item.id) ? 'You cannot impersonate yourself' : 'Impersonate ' + item.firstName + ' ' + item.lastName"
                type="Impersonate"></app-icon>
            </td>
          </tr>
        }
        @if (this.options.selectAction == 'expand') {
          <tr
            id="trdetails_{{ item.id }}"
            class="rowDetails noHover"
            style="display: none"
          >
            <td colspan="5">
              <div style="height: 100px">[helpful at-a-glance info goes here]</div>
            </td>
          </tr>
        }
      }
    }
  </tbody>
</table>
